import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2f1ec523"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drop-shadow-lg rounded-lg bg-white duration-300 transition group-hover:drop-shadow-xl" }
const _hoisted_2 = { class: "group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-t-lg bg-gray-100 relative duration-300 transition group-hover:opacity-90" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "m-1 rounded-full bg-gray-100 w-7 h-7 flex items-center justify-center overflow-hidden" }
const _hoisted_7 = { class: "m-1 rounded-full bg-gray-100 w-7 h-7 flex items-center justify-center overflow-hidden" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex flex-wrap items-center min-h-12 min-w-0" }
const _hoisted_10 = { class: "flex-1 min-w-0" }
const _hoisted_11 = { class: "text-sm xs:text-base sm:text-lg font-bold text-gray-700 group-hover/text:text-orange-700 truncate" }
const _hoisted_12 = { class: "text-xs flex items-center gap-3" }
const _hoisted_13 = { class: "text-gray-700 group-hover/text:text-orange-700 truncate" }
const _hoisted_14 = {
  key: 0,
  class: "bg-yellow-200 text-yellow-800 px-2 py-0.5 rounded-lg truncate"
}
const _hoisted_15 = { class: "text-right cursor-default" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "min-w-28 text-xs" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "flex items-center mt-1" }
const _hoisted_21 = { class: "w-8" }
const _hoisted_22 = { class: "text-thin" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = { class: "w-8" }
const _hoisted_25 = { class: "text-thin" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "w-8" }
const _hoisted_28 = { class: "text-xs text-thin" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  class: "text-base sm:text-lg lg:text-xl font-bold text-gray-800 ml-2"
}
const _hoisted_31 = {
  key: 0,
  class: "min-w-36 text-xs"
}
const _hoisted_32 = { class: "font-semibold" }
const _hoisted_33 = {
  key: 0,
  class: "flex justify-between text-thin"
}
const _hoisted_34 = {
  key: 1,
  class: "flex justify-between text-thin"
}
const _hoisted_35 = {
  key: 0,
  class: "min-w-40 text-xs"
}
const _hoisted_36 = { class: "ml-2" }
const _hoisted_37 = { class: "font-semibold" }
const _hoisted_38 = { class: "ml-1" }

import { library } from "@fortawesome/fontawesome-svg-core";
import { faDroplet, faWind, faTemperatureHalf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/vue/24/outline";
import { format } from "date-fns";
import { computed, PropType, ref } from "vue";
import OaiTooltip from "shared/components/other/OaiTooltip.vue";
import { useHasPermission } from "shared/composables/project";
import logger from "shared/services/logger";
import { SimplifiedProject, ProjectExtendedData } from "shared/types/Project";
import { WeatherItem } from "shared/types/Weather";
import { useDeltaTextClass, useFormattedDelta } from "shared/views/critical_path/composables";
import defaultProjectThumbnailUrl from "@/assets/imgs/default-project-thumbnail.jpg";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCard',
  props: {
  project: {
    type: Object as PropType<SimplifiedProject>,
    required: true,
  },
  thumbnailUrls: {
    type: Array as PropType<string[]>,
    required: false,
  },
  weather: {
    type: Object as PropType<WeatherItem>,
    required: false,
  },
  extendedData: {
    type: Object as PropType<ProjectExtendedData>,
    required: false,
  },
},
  setup(__props) {

library.add(faDroplet, faWind, faTemperatureHalf);

const props = __props;

const selectedThumbnailIdx = ref<number>(0);
const isSwiping = ref<boolean>(false);
const swipeDirection = ref<"left" | "right">("right");

const delta = computed(() => props.extendedData?.delta_working_days ?? null);
const deltaClass = useDeltaTextClass(delta);
const formattedDelta = useFormattedDelta(delta);

const formatDate = (date: Date) => {
  return format(date, "dd.MM.yyyy");
};

const formatNumber = (number: number) => {
  return number ? (Number.isInteger(number) ? number.toString() : number.toFixed(2)) : 0;
};
const formatTimestamp = (timestamp: string) => {
  return `${format(new Date(timestamp), "dd.MM.yy, HH")}:00`;
};

const getIconUrl = (iconId: string) => {
  try {
    return require(`@/assets/imgs/weather_icons/${iconId}.png`);
  } catch (error) {
    logger.error(error);
    return null;
  }
};

const handlePaginateByIdx = (event: Event, idx: number) => {
  event.stopPropagation();
  event.preventDefault();

  if (idx === selectedThumbnailIdx.value) return;

  isSwiping.value = true;

  swipeDirection.value = idx > selectedThumbnailIdx.value ? "right" : "left";
  selectedThumbnailIdx.value = idx;

  setTimeout(() => {
    isSwiping.value = false;
  }, 500);
};

const handlePaginateByDirection = (event: Event, direction: "left" | "right") => {
  event.stopPropagation();
  event.preventDefault();

  isSwiping.value = true;
  swipeDirection.value = direction;

  if (!props?.thumbnailUrls) {
    return;
  }

  if (swipeDirection.value === "right") {
    if (selectedThumbnailIdx.value + 1 < props.thumbnailUrls.length) {
      selectedThumbnailIdx.value += 1;
    } else {
      selectedThumbnailIdx.value = 0;
    }
  }

  if (swipeDirection.value === "left") {
    if (selectedThumbnailIdx.value - 1 < 0) {
      selectedThumbnailIdx.value += props.thumbnailUrls.length - 1;
    } else {
      selectedThumbnailIdx.value -= 1;
    }
  }

  setTimeout(() => {
    isSwiping.value = false;
  }, 500);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {
      name: 'ProjectOverview',
      params: {
        customer_name: __props.project.customer_name,
        site_id: __props.project.site_id,
      },
    },
    class: "group relative",
    style: {"-webkit-transform":"translateZ(0)"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.thumbnailUrls && __props.thumbnailUrls.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "absolute inset-0 flex transition-transform duration-500 ease-in-out",
                style: _normalizeStyle({ transform: `translateX(-${selectedThumbnailIdx.value * 100}%)` })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.thumbnailUrls, (url, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex-shrink-0 w-full h-full"
                  }, [
                    _createElementVNode("img", {
                      src: url,
                      alt: "",
                      class: "w-full h-full object-cover transition-opacity duration-500 ease-in-out",
                      loading: "lazy",
                      style: _normalizeStyle({
                backgroundImage: `url('${_unref(defaultProjectThumbnailUrl)}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                textIndent: '-1000px',
              })
                    }, null, 12, _hoisted_3)
                  ]))
                }), 128))
              ], 4))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _unref(defaultProjectThumbnailUrl),
                class: "absolute inset-0 w-full h-full object-cover",
                loading: "lazy"
              }, null, 8, _hoisted_4)),
          (__props.thumbnailUrls && __props.thumbnailUrls.length >= 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "absolute opacity-0 group-hover:opacity-90 transition-opacity duration-300 flex items-center justify-center top-1/2 transform -translate-y-1/2 left-2",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handlePaginateByDirection($event, 'left')), ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(ArrowLeftIcon), { class: "w-3 h-3 fill-current text-black" })
                  ])
                ]),
                _createElementVNode("div", {
                  class: "absolute opacity-0 group-hover:opacity-90 transition-opacity duration-300 flex items-center justify-center top-1/2 transform -translate-y-1/2 right-2",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handlePaginateByDirection($event, 'right')), ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(ArrowRightIcon), { class: "w-3 h-3 fill-current text-black" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.thumbnailUrls && __props.thumbnailUrls.length >= 2)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "absolute bottom-13 rounded-full flex items-center justify-center left-1/2 transform -translate-x-1/2",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.thumbnailUrls.length, (i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", {
                    onClick: _withModifiers(($event: any) => (handlePaginateByIdx($event, i - 1)), ["stop"]),
                    class: _normalizeClass(["px-1 py-3", {
              'pl-6': i - 1 === 0,
              'pr-6': i - 1 === __props.thumbnailUrls.length - 1,
            }])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'w-1.5 h-1.5 rounded-full transition-transform duration-300 ease-in-out hover:scale-125',
                i - 1 === selectedThumbnailIdx.value ? 'bg-yellow scale-125' : 'bg-gray-200',
              ])
                    }, null, 2)
                  ], 10, _hoisted_8)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "p-4 cursor-default",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"]))
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: {
              name: 'ProjectOverview',
              params: {
                customer_name: __props.project.customer_name,
                site_id: __props.project.site_id,
              },
            },
              class: "group/text flex-1 min-w-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h2", _hoisted_11, _toDisplayString(__props.project.name), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(`${formatDate(__props.project.planned_start)} - ${
                      __props.project.status === "completed" && __props.project.planned_end
                        ? formatDate(__props.project.planned_end)
                        : _ctx.$t("calendar.today").toLowerCase()
                    }`), 1),
                    (__props.project.status === 'completed')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("project.status.completed")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (__props.project.status === 'active' && __props.weather)
                  ? (_openBlock(), _createBlock(OaiTooltip, {
                      key: 0,
                      position: "top",
                      cls: "shrink-0"
                    }, {
                      tooltip: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          (__props.weather.timestamp)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(formatTimestamp(__props.weather.timestamp)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-temperature-half" })
                            ]),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(__props.weather.temperature) + "°C", 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-droplet" })
                            ]),
                            _createElementVNode("div", _hoisted_25, _toDisplayString(formatNumber(__props.weather.rain)) + " mm", 1)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-wind" })
                            ]),
                            _createElementVNode("div", _hoisted_28, _toDisplayString(__props.weather.wind) + " " + _toDisplayString(_ctx.$t("dashboard.project.weather_card.kmh")), 1)
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "rounded-full h-12 w-12",
                          src: getIconUrl(__props.weather.icon_local),
                          alt: ""
                        }, null, 8, _hoisted_17)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.extendedData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(OaiTooltip, { position: "top" }, {
                        tooltip: _withCtx(() => [
                          (__props.extendedData)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("dashboard.home.project_card.schedule_progress")), 1),
                                (__props.extendedData.duration_progress_actual)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("dashboard.home.project_card.actual_progress")) + ":", 1),
                                      _createElementVNode("div", null, _toDisplayString(`${(__props.extendedData.duration_progress_actual * 100).toFixed(1)}%`), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (__props.extendedData.duration_progress_planned)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("dashboard.home.project_card.planned_progress")) + ":", 1),
                                      _createElementVNode("div", null, _toDisplayString(`${(__props.extendedData.duration_progress_planned * 100).toFixed(1)}%`), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          (
                      __props.extendedData &&
                      __props.extendedData.duration_progress_actual &&
                      _unref(useHasPermission)(['planner_user'], __props.project.customer_name, __props.project.site_id) &&
                      _unref(useHasPermission)(['processes_user'], __props.project.customer_name, __props.project.site_id)
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(Math.round(__props.extendedData.duration_progress_actual * 100)) + "% ", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(OaiTooltip, { position: "top" }, {
                        tooltip: _withCtx(() => [
                          (__props.extendedData && __props.extendedData.delta_working_days !== null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("dashboard.home.project_card.planner_delta")) + ":", 1),
                                  _createElementVNode("span", _hoisted_36, [
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(formattedDelta)), 1),
                                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t(`working_day.working_day`)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          (
                      __props.extendedData.delta_working_days !== null &&
                      _unref(useHasPermission)(['planner_user'], __props.project.customer_name, __props.project.site_id)
                    )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([_unref(deltaClass), 'text-xs'])
                              }, _toDisplayString(`${_unref(formattedDelta)} ${_ctx.$t(`working_day.working_day_abbrev`)}`), 3))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})